import { Header, useAppSelector } from "@shared/ui";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import FormChangeEmail from "./components/FormChangeEmail";
import FormCode from "./components/FormCode";
import ChangePasswordForm from "./components/ChangePasswordForm";

const Profile: React.FC = () => {
  const { t } = useTranslation();
  const user = useAppSelector((store) => store.user.value);

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showVereficationCode, setShowVereficationCode] = useState(false);
  const [showChangePassModal, setChangePassModal] = useState(false);
  const [email, setEmail] = useState<string>("");

  const closeEmailModal = () => {
    setShowEmailModal(false);
  }

  const closeChangePassModal = () => {
    setChangePassModal(false);
  }

  const setResult = (result: {email: string, res: boolean}) => {
    setEmail(result.email);
    setShowVereficationCode(result.res);
  }

  return (
    <div className="container">
      <Header />

      <div className="drone-list-item">
        <div className="drone-list-item-description">
          <div className="drone-list-item-name">
            <h3>
              {user?.login}
            </h3>{" "}
            - {user?.customerName}
          </div>
          {user?.email && <div className="drone-list-item-use">{user?.email}</div>}
          <div className="group-btn">
            <>
              <button
                className="btn"
                onClick={() => setShowEmailModal(true)}
              >
                {Boolean(user?.email) ? t("profile.buttons.changeEmail") : t("profile.buttons.addEmail")}
              </button>
              <button
                className="btn"
                disabled={Boolean(!user?.email)}
                onClick={() => setChangePassModal(true)}
              >{t("profile.buttons.changePassword")}</button>
            </>
            <small>{Boolean(!user?.email) && t("profile.emailHint")}</small>
          </div>
        </div>
      </div>

      {showEmailModal && <div className="modal-wrapper">
        <dialog open onCancel={closeEmailModal}>
          {!showVereficationCode && <div className="modal-header">
            <h4>{t("profile.addEmailModal.title")}</h4>
            <button onClick={closeEmailModal}>✕</button>
          </div>}

          {!showVereficationCode && user?.id ?
            <FormChangeEmail userId={user?.id} setResult={setResult} /> :
            user?.id && <FormCode email={email} setShowEmailModal={setShowEmailModal} />}
        </dialog>
      </div>}

      {showChangePassModal && <div className="modal-wrapper">
        <dialog open onCancel={closeChangePassModal}>
          <div className="modal-header">
            <h4>{t("profile.changePasswordModal.title")}</h4>
            <button onClick={closeChangePassModal}>✕</button>
          </div>

          {user?.id && <ChangePasswordForm userId={user?.id} setChangePassModal={setChangePassModal} />}
        </dialog>
      </div>}

    </div>
  )
}

export default Profile;